import { generateClient, GraphQLResult } from "aws-amplify/api";
// @ts-ignore
import { getFieldContinuationData } from "../graphql/queries";
import { getFieldContinuationDataDocument } from "../db/queries/fieldContinuationDataQueries";
import { recordSentry } from "./recordSentry";
import { FieldContinuationDataForResolver } from "db/definitions";

async function getContinuationData(id: string, online: boolean) {
	try {
		if (online) {
			interface QueryResult {
				getFieldContinuationData: FieldContinuationDataForResolver;
			}
			const client = generateClient({ authMode: "userPool" });
			const result = (await client.graphql({
				query: getFieldContinuationData,
				variables: {
					id,
				},
				authMode: "userPool",
			})) as GraphQLResult<QueryResult>;
			return result.data.getFieldContinuationData;
		} else {
			const doc = await getFieldContinuationDataDocument(id);
			return doc;
		}
	} catch (error) {
		recordSentry({ error, msg: "Error getting field continuation data: " });
	}
	return null;
}

export default getContinuationData;
